module.exports = __webpack_public_path__ + "assets/images/industry_phase2.568e2bdc328525397f01a358a062eaf6.svg";